import React from 'react';
import IamScanTable from './IamScanTable';

const IamScanPanel = () => {
  return <IamScanTable />;
};

export default IamScanPanel;